<template>
  <div
    v-if="name"
    class="dg-modal-background"
    @click="clickedAway"
  >
    <div
      class="dg-modal"
      @click.stop
    >
      <component
        :is="name"
        v-bind="otherProps"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import BuildingSignupsModal from "@/components/modals/BuildingSignupsModal"
  import ContentDetailsModal from "@/components/modals/ContentDetailsModal"
  import DownloadReportsModal from "@/components/modals/DownloadReportsModal"
  import InvitationFormModal from "@/components/modals/InvitationFormModal"
  import InvitationLinkModal from "@/components/modals/InvitationLinkModal"
  import MoveFileModal from "@/components/modals/MoveFileModal"
  import SelectPhotoModal from "@/components/modals/SelectPhotoModal"
  import StripeSetupModal from "@/components/modals/StripeSetupModal"

  export default {
    components: {
      BuildingSignupsModal,
      ContentDetailsModal,
      DownloadReportsModal,
      InvitationFormModal,
      InvitationLinkModal,
      MoveFileModal,
      SelectPhotoModal,
      StripeSetupModal,
    },
    props: {
      account: {
        default: null,
        required: false,
        type: Object,
      },
      channelId: {
        required: false,
        default: null,
        type: Number,
      },
      content: {
        required: false,
        default: null,
        type: Object,
      },
      contextShare: {
        required: false,
        default: null,
        type: Object,
      },
      initialValues: {
        default: null,
        required: false,
        type: Object,
      },
      modalVariant: {
        default: null,
        required: false,
        type: String,
      },
      name: {
        required: true,
        type: String,
      },
      rallyId: {
        required: false,
        default: null,
        type: Number,
      },
    },
    computed: {
      otherProps() {
        const nonNameProps = Object.assign({}, this.$props)
        delete nonNameProps.name
        return nonNameProps
      }
    },
    methods: {
      ...mapActions("user", ["setModalProps"]),
      clickedAway() {
        this.setModalProps({})
      },
    },
  }
</script>
